import {fabric} from "fabric";
import {StoredTemplate, Template} from "../types/Individualization";

export const changeBackground = (template: StoredTemplate|Template, canvas: fabric.Canvas) => {
    fabric.Image.fromURL(template.src, (fabricImage: fabric.Image) => {
        const scale = canvas.getWidth()

        const img = fabricImage.set({
            originX: 'center',
            originY: 'center',
            centeredScaling: true,
            left: scale / 2,
            top: scale / 2,
        })

        const scaleRatio = Math.min(scale / img.getScaledWidth(), scale / img.getScaledHeight());

        canvas.setBackgroundImage((img as fabric.Image), canvas.renderAll.bind(canvas), {
            scaleX: scaleRatio,
            scaleY: scaleRatio
        });
    });
}

export const resizeFabricObject = (object: fabric.Object, sizing: number) => {
    if (!object.data?.size || object.data?.size === sizing) return

    const factor = sizing / object.data.size;
    object.data.size = sizing

    if (object.top) object.set('top', Math.round(object.top * factor * 100) / 100)
    if (object.left) object.set('left', Math.round(object.left * factor * 100) / 100)

    if (object.height && object.type !== 'image') {
        object.set('height', Math.round(object.height * factor * 100) / 100)
    }
    if (object.width && object.type !== 'image') {
        object.set('width', Math.round(object.width * factor * 100) / 100)
    }

    //Ellipse
    if (object instanceof fabric.Ellipse && object.ry) {
        object.set('ry', Math.round(object.ry * factor * 100) / 100)
    }
    if (object instanceof fabric.Ellipse && object.rx) {
        object.set('rx', Math.round(object.rx * factor * 100) / 100)
    }

    //Circle
    if (object instanceof fabric.Circle && object.radius) {
        object.set('radius', Math.round(object.radius * factor * 100) / 100)
    }

    //Image
    if (object.type === 'image') {
        if (object.scaleX) object.set('scaleX', object.scaleX * factor)
        if (object.scaleY) object.set('scaleY', object.scaleY * factor)
    }

    //Text
    if (object instanceof fabric.Text && object.fontSize) {
        object.set('fontSize', Math.round(object.fontSize * factor * 100) / 100)
    }


    //Polygon
    if (object instanceof fabric.Polygon) {
        for (const point of (object.points ?? [])) {
            point.x = Math.round(point.x * factor * 100) / 100
            point.y = Math.round(point.y * factor * 100) / 100
        }

        const { width, height, left, top } = object._calcDimensions();
        object.set({
            width,
            height,
            pathOffset: new fabric.Point(left + width / 2, top + height / 2),
            dirty: true
        }).setCoords();
    }
}

export const rescaleFabricObject = (object: fabric.Object) => {
    if (object.top) object.set('top', Math.round(object.top * 100) / 100)
    if (object.left) object.set('left', Math.round(object.left * 100) / 100)
    if (object.angle) object.set('angle', Math.round(object.angle * 100) / 100)

    if (object.height && object.scaleY) {
        object.set('height', Math.round(object.height * object.scaleY * 100) / 100)
    }
    if (object.width && object.scaleX) {
        object.set('width', Math.round(object.width * object.scaleX * 100) / 100)
    }

    //Ellipse
    if (object instanceof fabric.Ellipse && object.ry && object.scaleY) {
        object.set('ry', Math.round(object.ry * object.scaleY * 100) / 100)
    }
    if (object instanceof fabric.Ellipse && object.rx && object.scaleX) {
        object.set('rx', Math.round(object.rx * object.scaleX * 100) / 100)
    }

    //Circle
    if (object instanceof fabric.Circle && object.radius && object.scaleX) {
        object.set('radius', Math.round(object.radius * object.scaleX * 100) / 100)
    }

    //Polygon
    if (object instanceof fabric.Polygon) {
        console.log(object)
    }

    //clean scale-factor
    if (object.scaleX) object.set('scaleX', 1)
    if (object.scaleY) object.set('scaleY', 1)

    return object
}
